import React from "react";
import { Box, Typography, Card, CardMedia, CardContent } from "@mui/material";
import { ProductData } from "../services/product/types";
import { useTheme } from "@mui/material/styles";

type IProps = {
  item: {
    productData: ProductData;
    quantity: number;
  };
};

const OrderSummaryCard: React.FC<IProps> = ({ item }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        padding: 2,
        borderRadius: 2,
        boxShadow: 3,
        backgroundColor: "#f5f5f5",
        width: "100%",
      }}
    >
      {/* Product Image */}
      <CardMedia
        component="img"
        image={
          item.productData.images
            ? `https://bootleggersdistribution.net${item.productData.images[0]?.path}`
            : ""
        }
        alt={item.productData.name}
        sx={{
          width: 80,
          height: 80,
          objectFit: "cover",
          borderRadius: 1,
        }}
      />

      {/* Product Details */}
      <CardContent sx={{ flex: 1, padding: "8px 0" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: { sm: 16, md: 18 },
            fontFamily: "Spectral, serif",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {item.quantity} × {item.productData.name}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.grey[600],
            fontFamily: "Spectral, serif",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {item.productData.description}
        </Typography>
      </CardContent>

      {/* Price */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          fontFamily: "Spectral, serif",
          color: theme.palette.text.primary,
          minWidth: "80px",
          textAlign: "right",
        }}
      >
        ${(item.quantity * item.productData.price).toFixed(2)}
      </Typography>
    </Card>
  );
};

export default OrderSummaryCard;
